import { type WorkflowData } from '../workflow';

export const getResolutionId = (
  data: WorkflowData | null,
  itemId?: string,
): string | undefined => {
  // Handle nested workflow data with valid item ID
  if (itemId && data?.items?.[itemId]) {
    const itemData = data.items[itemId];
    // Check if resolution exists and has resolutionId property
    if (
      itemData.resolution &&
      typeof itemData.resolution === 'object' &&
      'resolutionId' in itemData.resolution
    ) {
      return itemData.resolution.resolutionId;
    }
    return undefined;
  }

  // Handle flat workflow data
  if (
    data?.resolution &&
    typeof data.resolution === 'object' &&
    'resolutionId' in data.resolution
  ) {
    return data.resolution.resolutionId;
  }

  return undefined;
};
